module.exports = __webpack_public_path__ + "img/shared_documents.68a45bac.svg";